// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"410":"edd0c328","729":"d3a9791d"}[chunkId] + ".chunk.css";
};